export default [
    {
        path: '',
        name: 'TentangKami',
        component: () => import('./page-tentang-kami')
    }
]